import { Col, Row } from 'antd';
import { FC } from 'react';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

/** 拓店任务：加盟（三津汤包）-详情-拓店任务信息 */
const TaskInfo: FC<{
  detail: any;
}> = ({ detail }) => {
  const methods = useMethods({
    renderShopAddresses(value: any) {
      if (!isArray(value)) return value;
      const addresses = value.map((item: any) => {
        const area = [item?.provinceName, item?.cityName, item?.districtName].filter((areaItem) => isNotEmptyAny(areaItem)).join('/');
        return [area, item?.address].filter((addressItem) => isNotEmptyAny(addressItem)).join(' ');
      }).filter((item: any) => isNotEmptyAny(item));
      return addresses.join('，');
    },
    getInfos() {
      return [
        { label: '任务名称', value: detail?.name },
        { label: '加盟商名称', value: detail?.standardFranchiseeName || detail?.franchiseeDetail?.name },
        { label: '加盟商手机', value: detail?.standardFranchiseeMobile || detail?.franchiseeDetail?.mobile },
        { label: '加盟商编号', value: detail?.standardFranchiseeUniqueId || detail?.franchiseeDetail?.uniqueId },
        { label: '意向城市', value: detail?.targetArea },
        { label: '铺位地址', value: methods.renderShopAddresses(detail?.storeAddress || detail?.shopAddresses) },
      ];
    },
  });

  const infos = methods.getInfos();

  return detail ? <Row gutter={16}>
    {
      infos.map((item) => <Col span={8} key={item.label}>
        <V2DetailItem label={item.label} value={item.value} />
      </Col>)
    }
  </Row> : <></>;
};

export default TaskInfo;
